var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_106-receive-1",
    "data-name": "106-receive-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.822,
    height: 66.396,
    viewBox: "0 0 68.822 66.396",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M64.446,53.331V34.118a.979.979,0,0,0-.493-.847L37.21,17.831a.975.975,0,0,0-.975,0L9.505,33.263A.975.975,0,0,0,9,34.118v33.56a.975.975,0,0,0,.488.844L36.235,83.965a.975.975,0,0,0,.975,0l14.366-8.293A14.349,14.349,0,1,0,64.446,53.331ZM52.2,28.739l-24.8,14.315-4.866-2.81L47.337,25.93ZM26.414,44.716V62.591l-1.838-2.073a1.007,1.007,0,0,0-1.125-.257l-1.913.781V41.933ZM36.723,19.8l8.664,5-24.8,14.316-8.663-5Zm-.975,61.63L10.95,67.115V35.8l8.637,5V62.5a.994.994,0,0,0,1.368.9l2.6-1.071,3.073,3.489a.977.977,0,0,0,.733.331,1.054,1.054,0,0,0,.359-.063.989.989,0,0,0,.645-.912V45.842l7.383,4.279Zm.975-33-7.364-4.251,24.8-14.315,7.363,4.251Zm.975,33V50.121L62.5,35.8V53.331A14.351,14.351,0,0,0,50.6,73.986Zm25.773-1.387a12.4,12.4,0,1,1,12.4-12.4,12.4,12.4,0,0,1-12.4,12.4Z",
    transform: "translate(-9 -17.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M241.9,248.745a.977.977,0,0,0-1.57.208l-2.354,4.38a.975.975,0,0,0,.858,1.437,1,1,0,0,0,.877-.514l.537-.968v8.383a.975.975,0,1,0,1.95,0v-9.8l.793.857a.971.971,0,1,0,1.406-1.339Z",
    transform: "translate(-205.98 -216.295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M34.975,338.45a.975.975,0,0,0-.975.975v3.611a.975.975,0,1,0,1.95,0v-3.611A.975.975,0,0,0,34.975,338.45Z",
    transform: "translate(-30.517 -293.766)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M62.975,357.65a.975.975,0,0,0-.975.975v3.253a.975.975,0,0,0,1.95,0v-3.253A.975.975,0,0,0,62.975,357.65Z",
    transform: "translate(-54.617 -310.291)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M91.975,376.85a.975.975,0,0,0-.975.975v2.864a.975.975,0,1,0,1.95,0v-2.864A.975.975,0,0,0,91.975,376.85Z",
    transform: "translate(-79.577 -326.817)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M119.975,396.05a.975.975,0,0,0-.975.975V399.5a.975.975,0,1,0,1.95,0v-2.476A.975.975,0,0,0,119.975,396.05Z",
    transform: "translate(-103.676 -343.342)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M148,418.365a.975.975,0,1,0,1.95,0v-2.14a.975.975,0,1,0-1.95,0Z",
    transform: "translate(-128.636 -359.867)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M245.7,352.659l-4.443,2.565a.975.975,0,1,0,.975,1.689l4.443-2.565a.975.975,0,0,0-.975-1.689Z",
    transform: "translate(-208.481 -305.883)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M360.895,342.268l-8.568,6.97-2.614-3.062a.975.975,0,1,0-1.483,1.266l3.232,3.786a.975.975,0,0,0,1.357.123l9.306-7.572a.975.975,0,0,0-1.231-1.513Z",
    transform: "translate(-300.771 -296.864)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox3);
export default __webpack_public_path__ + "static/media/box3.dbb7d6d6fc4da43fe50a71fd4d7adb4a.svg";
export { ForwardRef as ReactComponent };